import React from "react"
import { Col, Row, Select } from "antd"
import { SelectProps } from "antd/lib/select"
import { useStore, useStoreState } from "hooks"
import { getAsset, getMembersToAssign } from "lib/helper"
import Avatar from "../Avatar"
import { session } from "store"
import CustomSelect from "components-old/forms/CustomSelect"
import { twMerge } from "tailwind-merge"
import { IMember } from "models/members"
import { isAldeia } from "hooks/useAldeia"

interface IAgentsSelectProps extends SelectProps<any> {
  checkDisabled?: Function
  unassigned?: boolean
  beforeOption?: React.ReactNode
  filter?: (member: IMember) => boolean
}

function AgentsSelect({ checkDisabled, beforeOption, unassigned, ...props }: IAgentsSelectProps) {
  const operatorStore = useStoreState((state) => state.members)
  const { all: groups } = useStoreState((state) => state.groups)
  const { user } = useStore(session)
  const members = getMembersToAssign(user.id, operatorStore.all, groups)
  let finalMembers = members

  if (props.filter) {
    finalMembers = members.filter(props.filter)
  }

  return (
    <CustomSelect allowClear showSearch {...props}>
      {beforeOption}
      {unassigned && (
        <Select.Option value={0} key={0} data-search="Não atribuído">
          <div className="flex items-center h-full gap-2 truncate flex-nowrap">
            <i className="w-5 far fa-user-slash" />
            <span className="truncate">Não atribuído</span>
          </div>
        </Select.Option>
      )}
      {finalMembers.map((operator: any) => (
        <Select.Option value={operator.id} key={operator.id} disabled={checkDisabled?.(operator)} data-search={operator.name}>
          <div className="flex items-center h-full gap-2 truncate flex-nowrap">
            <Avatar name={operator.name} index={operator.id} fontSize={10} size={isAldeia ? 18 : 20} imgSrc={getAsset(operator.avatar!)} />
            <span className={twMerge("truncate", !operator?.isActive && "line-through")}>
              {operator.name}
              {user.id == operator.id ? " (Você)" : ""}
            </span>
          </div>
        </Select.Option>
      ))}
    </CustomSelect>
  )
}

export default AgentsSelect
